// extracted by mini-css-extract-plugin
export default {"btn":"btnSmall_btn__FfP4B","icon":"btnSmall_icon__58Bw-","fixed-width":"btnSmall_fixed-width__CEW5O"};